/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import {
  AddMemberForm,
  Feedbacktext,
  InputLabel,
  InputWrapper,
  PopupInput,
  UpdateButton,
  ErrorText,
  WhitelistSelect,
  TextArea,
} from './editWaitlistPopupElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

// REGEX
const EMAIL_REGEX = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;

// Default state
const initialState = {
  email: '',
  wallet: '',
  twitter: '',
  discord: '',
  amount: '',
  referrer: '',
  notes: '',
  businessName: '',
  industry: '',
  contactName: '',
  phone: '',
};

const EditWaitlistPopup = ({
  setOpen, setData, selected, trigger, data, referrers,
}) => {
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [state, setState] = useState(initialState);
  const [validEmail, setValidEmail] = useState(false);

  const handleInput = (e) => {
    const input = e.currentTarget.name;
    const { value } = e.currentTarget;

    setState((prev) => ({ ...prev, [input]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!state.wallet) {
      return setFeedback('Wallet cant be empty');
    }

    // Security
    const v1 = EMAIL_REGEX.test(state.email);

    if (state.email && !v1) {
      setFeedback('Invalid email entry');
      return;
    }

    setLoading(true);

    axiosPrivate.post(
      '/editWaitlist',
      JSON.stringify({
        email: state.email,
        editedWallet: state.wallet,
        wallet: selected.Wallet,
        businessName: state.businessName,
        industry: state.industry,
        contactName: state.contactName,
        phone: state.phone,
        twitter: state.twitter,
        discord: state.discord,
        amount: state.amount,
        referrer: state.referrer,
        notes: state.notes,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setLoading(false);
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setState(initialState);
      } else {
        setFeedback(res.data.message);
        const editedData = data.map((item) => {
          if (item.idWaitlist === selected.idWaitlist) {
            return {
              ...item,
              Email: state.email,
              Wallet: state.wallet,
              BusinessName: state.businessName,
              Industry: state.industry,
              ContactName: state.contactName,
              Phone: state.phone,
              Twitter: state.twitter,
              Discord: state.discord,
              Amount: state.amount,
              Referrer: state.referrer,
              Notes: state.notes,
            };
          } return item;
        });
        setData(editedData);
        setState(initialState);
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response?.data ? error.response.data.message : 'Something went wrong');
      setState(initialState);
    });
  };

  // Email verification
  useEffect(() => {
    const result = EMAIL_REGEX.test(state.email);
    setValidEmail(result);
  }, [state.email]);

  // Error handling
  useEffect(() => {
    if (state.email) { setFeedback(''); }
  }, [state.email]);

  useEffect(() => {
    setState({
      email: selected.Email ? selected.Email : '',
      wallet: selected.Wallet ? selected.Wallet : '',
      businessName: selected.BusinessName ? selected.BusinessName : '',
      industry: selected.Industry ? selected.Industry : '',
      contactName: selected.ContactName ? selected.ContactName : '',
      phone: selected.Phone ? selected.Phone : '',
      twitter: selected.Twitter ? selected.Twitter : '',
      discord: selected.Discord ? selected.Discord : '',
      amount: selected.Amount ? selected.Amount : '',
      referrer: selected.Referrer ? selected.Referrer : '',
      notes: selected.Notes ? selected.Notes : '',
    });
  }, [trigger]);

  return (
    <AddMemberForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="email">Email:</InputLabel>
        <PopupInput
          value={state.email}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="email"
          name="email"
        />
      </InputWrapper>
      { state.email && !validEmail && (
      <ErrorText id="uidnote">
        <AiFillInfoCircle />
        &nbsp;
        Please enter a valid E-mail adress.
      </ErrorText>
      )}
      <InputWrapper>
        <InputLabel htmlFor="wallet">Wallet:</InputLabel>
        <PopupInput
          value={state.wallet}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="wallet"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="businessName">Business Name:</InputLabel>
        <PopupInput
          value={state.businessName}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="businessName"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="industry">Industry:</InputLabel>
        <PopupInput
          value={state.industry}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="industry"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="contactName">Contact Name:</InputLabel>
        <PopupInput
          value={state.contactName}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="contactName"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="phone">Phone:</InputLabel>
        <PopupInput
          value={state.phone}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="tel"
          name="phone"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="twitter">Twitter:</InputLabel>
        <PopupInput
          value={state.twitter}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="twitter"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="discord">Discord:</InputLabel>
        <PopupInput
          value={state.discord}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="discord"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="amount">Amount:</InputLabel>
        <PopupInput
          value={state.amount}
          onChange={handleInput}
          aria-describedby="uidnote"
          type="number"
          name="amount"
          min="1"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="referrer">Referrer:</InputLabel>
        <WhitelistSelect
          value={state.referrer}
          onChange={handleInput}
          aria-describedby="uidnote"
          name="referrer"
        >
          <option value="">None</option>
          {referrers && referrers.map((item) => (
            <option key={item.ID} value={item.Name}>{item.Name}</option>
          ))}
        </WhitelistSelect>
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="notes">Notes:</InputLabel>
        <TextArea
          value={state.notes}
          onChange={handleInput}
          aria-describedby="uidnote"
          name="notes"
        />
      </InputWrapper>
      <UpdateButton disabled={loading} type="submit">{loading ? 'Editing member' : 'Edit member'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AddMemberForm>
  );
};

export default EditWaitlistPopup;
